/* eslint-disable react/no-array-index-key */
import React, {useRef, useState} from "react";
import {ChevronDown as ChevronDownIcon} from "react-feather";
import {useIntl} from "react-intl";
// import { Link as RouterLink } from 'react-router-dom';
import {useSelector} from "react-redux";

import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Popover,
  SvgIcon,
  Tooltip,
  Typography,
  makeStyles
} from "@material-ui/core";

// import { getContacts } from 'src/actions/chatActions';
import useFlatform from "src/hooks/useFlatform";

const useStyles = makeStyles((theme) => ({
  popover: {
    width: 320,
    padding: theme.spacing(2)
  },
  colorWhite: {
    color: "white"
  }
}));

function PlatformSelect() {
  const classes = useStyles();
  const ref = useRef(null);
  const {formatMessage} = useIntl();
  // const dispatch = useDispatch();
  const {user} = useSelector((state) => state.account);
  const [isOpen, setOpen] = useState(false);

  // const [anchorEl, setAnchorEl] = useState(null);
  const {flatform, saveFlatform} = useFlatform();
  // const [selectedIndex, setSelectedIndex] = useState(null);
  // const [values, setValues] = useState({
  //   flatformIndex: flatform.flatformIndex,
  // });

  // const handleClickListItem = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  const handleMenuItemClick = (event, platform) => {
    // setSelectedIndex(platform.key);
    // setValues({
    //   flatformIndex: platform
    // });

    saveFlatform({
      flatformIndex: platform
    });
    // setAnchorEl(null);

    setOpen(false);
  };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // useEffect(() => {
  //   dispatch(getContacts());
  // }, [dispatch]);
  // dashboardLayout.topBar.platform
  return (
    <>
      {user?.list_platform?.length === 1 && (
        <Tooltip
          title={formatMessage({
            id: "dashboardLayout-topBar-platform-yEeie",
            defaultMessage: "Flatform",
            description: ""
          })}
        >
          <IconButton color="inherit">
            <Typography color="textPrimary" variant="h5" className={classes.colorWhite}>
              {user.list_platform[0].name}
            </Typography>
          </IconButton>
        </Tooltip>
      )}
      {user?.list_platform?.length > 1 && (
        <>
          <Tooltip title="Contacts">
            <IconButton color="inherit" onClick={handleOpen} ref={ref}>
              <Typography color="textPrimary" variant="h5" className={classes.colorWhite}>
                {flatform && flatform.flatformIndex.id !== ""
                  ? flatform.flatformIndex.name
                  : formatMessage({
                      id: "dashboardLayout-topBar-platform-EcMkG",
                      defaultMessage: "Flatform Select",
                      description: ""
                    })}
              </Typography>
              <SvgIcon fontSize="small">
                <ChevronDownIcon />
              </SvgIcon>
            </IconButton>
          </Tooltip>
          <Popover
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            classes={{paper: classes.popover}}
            anchorEl={ref.current}
            onClose={handleClose}
            open={isOpen}
          >
            <Box mt={2}>
              <Menu
                // onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                keepMounted
                PaperProps={{className: classes.popover}}
                getContentAnchorEl={null}
                anchorEl={ref.current}
                open={isOpen}
                // anchorEl={anchorEl}
                // open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {user?.list_platform.map((platform, index) => (
                  <MenuItem
                    key={index}
                    // component={RouterLink}

                    // disabled={index === 0}
                    // selected={platform.key === selectedIndex.flatformIndex.key}
                    onClick={(event) => handleMenuItemClick(event, platform)}
                    // to="/app/social/profile"
                  >
                    {platform.name}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Popover>
        </>
      )}
    </>
  );
}

export default PlatformSelect;
